import { useNativeBackButton } from '@/hooks/useNativeBackButton';

/** Renders nothing; registers native back-button handling when in Capacitor. */
export function NativeBackButtonHandler() {
  useNativeBackButton();
  return null;
}
